import React from 'react';

import { Flex, HStack, Text, Input, Button } from '@chakra-ui/react';

import { useColors } from './colors';

/** Same behavior as listings Pagination; `rows` controls visibility instead of `listings`. */
const ItemsPagination = ({
  currentPage,
  totalPages,
  pageInput,
  setPageInput,
  handlePageChange,
  isLoading,
  rows,
}) => {
  const { inputColor } = useColors();

  const getPaginationRange = () => {
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    let startPage = Math.max(currentPage - halfRange, 1);
    let endPage = Math.min(startPage + maxButtons - 1, totalPages);

    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(endPage - maxButtons + 1, 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i += 1) {
      pages.push(i);
    }
    return pages;
  };

  if (isLoading || !rows || rows.length === 0 || totalPages <= 0) {
    return null;
  }

  return (
    <Flex justify="space-between" align="center" mt={4}>
      <HStack spacing={2}>
        <Text fontSize="sm">Page</Text>
        <Input
          size="sm"
          type="number"
          value={pageInput}
          onChange={(e) => setPageInput(Number(e.target.value))}
          width="60px"
          color={inputColor}
        />
        <Text fontSize="sm">of {totalPages}</Text>
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            const page = parseInt(String(pageInput), 10);
            if (page >= 1 && page <= totalPages) {
              handlePageChange(page);
            }
          }}
        >
          Go
        </Button>
      </HStack>

      <HStack spacing={2}>
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage <= 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </Button>
        {getPaginationRange().map((page) => (
          <Button
            key={page}
            size="sm"
            variant={parseInt(String(page), 10) === parseInt(String(currentPage), 10) ? 'solid' : 'outline'}
            colorScheme={
              parseInt(String(page), 10) === parseInt(String(currentPage), 10) ? 'blue' : 'gray'
            }
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Button>
        ))}
        {getPaginationRange()[getPaginationRange().length - 1] < totalPages && (
          <>
            <Text>...</Text>
            <Button
              size="sm"
              variant="outline"
              onClick={() => handlePageChange(totalPages)}
              colorScheme={
                parseInt(String(totalPages), 10) === parseInt(String(currentPage), 10)
                  ? 'blue'
                  : 'gray'
              }
            >
              {totalPages}
            </Button>
          </>
        )}
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage >= totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </Button>
      </HStack>
    </Flex>
  );
};

export default ItemsPagination;
